import React from "react";
import RouteArrow from "./RouteArrow";

interface RouteLineProps {
    label: string;
    bgColor: string;
    enabled?: boolean;
}

const RouteLine: React.FC<RouteLineProps> = ({ label, bgColor, enabled = true }) => {
    if (!enabled) return null;

    return (
        <div className="display-flex flex-row justify-content-left align-items-center width-50pct">
            <span className="display-flex text-size-10 text-normal text-color-dark text-nowrap width-60pct">
                {label}
            </span>
            <div className={` display-flex flex-row align-items-center justify-content-around height-100pct ${bgColor} width-100pct margin-left-10 margin-right-10 `}>
                {[...Array(5)].map((_, index) => (
                    <RouteArrow key={index} />
                ))}
            </div>
        </div>
    );
};

export default RouteLine;

